export const GtmEventComponent = {
    HEADER_MENU: 'header menu',
    HEADER: 'header',
    LANGUAGE_SELECTION_MENU: 'language selection menu',
    USER_MENU: 'user menu',
    HEADER_SUBMENU: 'header submenu',
    HEADER_MOBILE_MENU: 'header mobile menu',
    MOBILE_MENU: 'mobile menu',
    BANNER: 'banner',
    GAMES_CATEGORIES: 'games categories',
    GAMES_THUMBNAIL: 'game thumbnail',
    GAME_GRID: 'game grid',
    SORTING: 'sorting',
    FILTERS: 'filters',
    WINNER_TICKER: 'winner ticker',
    GRID_STRIP: 'grid strip',
    FOOTER: 'footer',
    PAYMENT_METHODS: 'payment methods icons',
    REGULATION_ICONS: 'regulation icons',
    SOCIAL_MEDIA_ICONS: 'social media icons',
};

export const GtmEventClickElement = {
    LINK: 'link',
    IMG: 'img',
    ICON: 'icon',
    BUTTON: 'button',
    SWIPE: 'swipe',
};

export const GtmEventLocation = {
    HEADER: 'header',
    MOBILE_MENU: 'mobile menu',
    LOBBY_BANNER: 'lobby banner',
    GAME_GRID: 'game grid',
    FOOTER: 'footer',
};
